module.exports = __webpack_public_path__ + "static/img/twjd-sde6-2.81b36e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde6-2.png
// module id = 843
// module chunks = 0